// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__rR_1p","info":"PatientInfo_info__uBNyd"};